import request from '@/api/request.js'

export const getNewsList = (pageNum, pageSize,type) => request({ url: `/news/list?pageNum=${pageNum}&pageSize=${pageSize}&type=${type}&status=1`, method: 'get' })

export const getNewsDetail = (id) => request({url:`/news/${id}`,method:'get'})
